import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AppProvider from "./context/AppProvider";
import { ConfigProvider } from "antd";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        components: {
          Skeleton: {
            gradientFromColor: "rgba(0, 0, 0, 0.07)",
            gradientToColor: "rgba(0, 0, 0, 0.6)",
          },
          Tabs: {
            itemColor: "#FFFFFF",
            itemSelectedColor: "#FFFFFF",
            itemHoverColor: "#FFFFFF",
            itemActiveColor: "none",
            inkBarColor: "none",
          },
          DatePicker: {
            activeBg: "#25252F",
            activeBorderColor: "transparent",
            hoverBorderColor: "#FD6F27",
            cellHoverWithRangeBg: "#422015",
            colorBgContainer: "#25252F",
            colorBorder: "transparent",
            colorText: "#FFFFFF",
            colorTextHeading: "#FFFFFF",
            colorBgElevated: "#25252F",
            colorIcon: "#FFFFFF",
            cellActiveWithRangeBg: "#422015",
            controlItemBgActive: "#422015",
            colorPrimary: "#FD6F27",
            colorIconHover: "#422015",
            colorTextDisabled	: "#FFFFFF"
          },
          Table: {
            headerBg: '#25252f',
            headerColor: '#92929e',
            headerSplitColor: 'transparent',
            borderColor: '#25252f',
            colorBgContainer: '#2f2f39',
            colorText: '#FFFFFF',
            fontFamily: 'Poppins-regular',
          },
          Pagination: {
            colorPrimary: '#FD6F27',
            colorPrimaryHover: '#FD6F27',
            colorPrimaryBorder: '#FD6F27',
            colorText: '#FFFFFF',
            itemActiveBg: 'transparent',
            colorTextDisabled: '#92929e',
            colorBgTextHover: '#FD6F27',
            stickyScrollBarBg: 'red',
          },
          Input: {
            activeBg: "transparent",
            colorText: "#FFFFFF",
            activeBorderColor: "#FD6F27",
            colorPrimaryHover: '#FD6F27'
          },
          Select: {
            colorBgContainer: "transparent",
            colorText: '#92929e',
            colorPrimary: '#FD6F27',
            optionActiveBg: '#2f2f39',
            colorBgElevated: '#25252F',            
            colorTextPlaceholder: '#92929E',
          }
        },
      }}
    >
      <AppProvider>
        <App />
      </AppProvider>
    </ConfigProvider>
  </React.StrictMode>
);
